import z from "zod";

export const getEmailParamsSchema = z.object({
	// A logged mail's id is a uuid and the read reaches a uuid column, so anything else is a bad
	// request rather than a lookup that fails inside the database.
	emailId: z.uuid(),
});

export type GetEmailParamsSchema = z.infer<typeof getEmailParamsSchema>;
